import React from "react";
import { attendeesData } from "../data/attendees";

function Attendees({ attendees }) {
  return (
    <div className="w-full overflow-x-scroll">
      <div className="border-t border-gray-70 lg:w-full w-[180%]">
        <div className="w-full flex border-b border-gray-70 p-2 font-semibold">
          <div className="w-[10%] flex justify-center">ID</div>
          <div className="w-[30%] flex justify-center">Name</div>
          <div className="w-[20%] flex justify-center">Email</div>
          <div className="w-[20%] flex justify-center">Location</div>
          <div className="w-[20%] flex justify-center">Phone</div>
        </div>
        {attendees.length < 1 ? (
          <p className="mt-2 capitalize">No Attendee available</p>
        ) : (
          attendees.map((attendee) => (
            <div
              key={attendee.id}
              className="w-full flex border-b border-gray-70 p-2"
            >
              <div className="w-[10%] flex justify-center items-center">
                {attendee.id}
              </div>
              <div className="w-[30%] flex justify-center items-center text-center">
                <p>{`${attendee.first_name} ${attendee.last_name}`}</p>
              </div>
              <div className="w-[20%] flex justify-center items-center text-center">
                <p>{attendee.email}</p>
              </div>
              <div className="w-[20%] flex justify-center items-center text-center">
                <p>{attendee.location}</p>
              </div>
              <div className="w-[20%] flex justify-center items-center text-center">
                <p>{attendee.phone_number}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Attendees;
